import { apiConfig } from '@/services/api-config';

export const getBillingAddress = async (tokenKey: string, cdUser: string) => apiConfig
  .get(`api/Agent/BillingAddressByCdUser?tokenKey=${tokenKey}&cdUser=${cdUser}`)
  .then((response) => response.data)
  .catch(() => []);
